/*
 * @Description: xxx
 * @version: 1.0
 * @Author: 3hljk
 */
export class PipeInfo {
  constructor() {
    this.pipeURL = '../../../../assets/pipedata.json'
    this.pipeRes = null;
  }

  /**
   * 通过id获取管道nodeName
   * @param {*} id 
   * @returns 
   */
  getPipeNodeNameById (id) {
    return new Promise((resolve, reject) => {
      this.getPipeInfo().then(() => {
        if (this.pipeRes != null) {
          for (var e of this.pipeRes) {
            if (e.id == id) {
              resolve(e.node_name)
            }
          }
          reject('this id is no name')
        } else {
          reject('pipeRes is null')
        }
      });

    })

  }

  /**
   * 通过id获取管道name
   * @param {*} id 
   * @returns 
   */
  getPipeNameById (id) {
    return new Promise((resolve, reject) => {
      this.getPipeInfo().then(() => {
        if (this.pipeRes != null) {
          for (var e of this.pipeRes) {
            if (e.id == id) {
              resolve(e.name)
            }
          }
          reject('this id is no name')
        } else {
          reject('pipeRes is null')
        }
      });

    })

  }

  /**
   * 获取管道信息
   */
  async getPipeInfo () {
    // 使用GIS数据库存储
    if (this.saveUrl == undefined) {
      gisCore.database.get(this.pipeURL).then(blob => {
        this.pipeURL = URL.createObjectURL(new Blob([blob]));
        this.saveUrl = true;
      })
    }
    await fetch(this.pipeURL).then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error('Network Error.')
    }).then((res) => {
      // this.pipeRes = res.find((e) => { return e.id === id })
      this.pipeRes = res
      return res
    })
  }

}